import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import axios from 'axios';
import Utils from '@this/domain/appoint/utils';
import SignInupForm from './sign_inup_form';

interface Response {
  google_oauth_path: string;
  outlook_oauth_path: string;
}

const UsersSignUp = observer(() => {
  const [googleOauthPath, setGoogleOauthPath] = useState<string>('');
  const [outlookOauthPath, setOutlookOauthPath] = useState<string>('');

  const fetchData = async () => {
    const res = await axios.get<Response>('/aicalendar/users/sign_up.json');
    setGoogleOauthPath(res.data.google_oauth_path);
    setOutlookOauthPath(res.data.outlook_oauth_path);
  };

  // マウント時に1回発動
  useEffect(() => {
    Utils.trackEvent('[cal][view] sign up');
    fetchData();
  }, []);

  return <SignInupForm googleOauthPath={googleOauthPath} outlookOauthPath={outlookOauthPath} />;
});

export default UsersSignUp;
